var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6837 4.0142L21.9813 10.3118L9.12052 23.1742C8.7929 23.5013 8.39823 23.7535 7.96372 23.9134L7.69972 23.9982L1.21172 25.7678C1.08604 25.8024 0.953804 25.8058 0.826517 25.7777C0.699229 25.7495 0.580747 25.6907 0.481381 25.6063C0.382015 25.5219 0.304775 25.4146 0.256382 25.2935C0.20799 25.1725 0.189911 25.0414 0.20372 24.9118L0.229319 24.7838L1.99892 18.2974C2.12052 17.8494 2.33812 17.4334 2.63572 17.0814L2.82292 16.8766L15.6837 4.0126V4.0142ZM18.1925 1.507C19.0091 0.691844 20.1102 0.225487 21.2639 0.20619C22.4175 0.186892 23.5336 0.616161 24.377 1.40355C25.2204 2.19094 25.7253 3.27497 25.7852 4.42723C25.845 5.57949 25.4553 6.71001 24.6981 7.5806L24.4901 7.8046L23.1125 9.1806L16.8149 2.883L18.1925 1.507Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.a0dfbf9a.svg";
export { ForwardRef as ReactComponent };